import { render, staticRenderFns } from "./AvisoPrivacidad.vue?vue&type=template&id=1318922b&scoped=true&"
import script from "./AvisoPrivacidad.vue?vue&type=script&lang=js&"
export * from "./AvisoPrivacidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318922b",
  null
  
)

export default component.exports